import { websiteRequest } from 'src/editor/shared/utils/request'
import {
  WebsiteThemeInterface,
  WebsiteThemeListInterface,
} from 'src/editor/store/website-settings/website-settings-types'

/**
 * @description discommend when the api is ready
 */

export const getWebsiteThemes = () =>
  websiteRequest<WebsiteThemeListInterface[]>('/themes', 'GET')

/**
 * @description discommend when the api is ready
 */
export const getWebsiteThemeById = (id: number) =>
  websiteRequest<WebsiteThemeInterface>(`/themes/${id}`, 'GET')
